import { render, staticRenderFns } from "./teacherAnimation.vue?vue&type=template&id=99d79c3e&scoped=true"
import script from "./teacherAnimation.vue?vue&type=script&lang=js"
export * from "./teacherAnimation.vue?vue&type=script&lang=js"
import style0 from "./teacherAnimation.vue?vue&type=style&index=0&id=99d79c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d79c3e",
  null
  
)

export default component.exports